import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
  doc,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  setDoc,
  onSnapshot,
} from 'firebase/firestore';
import { db } from '../firebaseConfig';

// Placeholder function to get all blueprints
export const getBlueprints = async () => {
  const blueprintsCol = collection(db, 'blueprints');
  const blueprintSnapshot = await getDocs(blueprintsCol);
  const blueprintList = blueprintSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  return blueprintList;
};

export const getBlueprintCustomerDetails = async (customerId) => {
  const blueprintCollectionRef = collection(db, 'blueprints');
  const blueprintQuery = query(
    blueprintCollectionRef,
    where('ownerId', '==', customerId)
  );
  const blueprintSnapshot = await getDocs(blueprintQuery);
  const blueprintList = blueprintSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  const blueprintListFirst = blueprintList?.[0];
  return blueprintListFirst;
};

// Placeholder function to get details for a single blueprint
export const getBlueprintDetails = async (blueprintId) => {
  const blueprintRef = doc(db, 'blueprints', blueprintId);
  const blueprintSnap = await getDoc(blueprintRef);
  if (blueprintSnap.exists()) {
    return { id: blueprintSnap.id, ...blueprintSnap.data() };
  } else {
    return null;
  }
};

// Placeholder function to create a new blueprint
export const createBlueprint = async (blueprintData) => {
  const blueprintsCol = collection(db, 'blueprints');
  const docRef = await addDoc(blueprintsCol, blueprintData);
  return docRef.id; // Return the new blueprint's ID
};

// Placeholder function to update a blueprint
export const updateBlueprint = async (blueprintId, updatedData) => {
  const blueprintRef = doc(db, 'blueprints', blueprintId);
  await setDoc(blueprintRef, updatedData);
  return true;
};

// Placeholder function to delete a blueprint
export const deleteBlueprint = async (blueprintId) => {
  const blueprintRef = doc(db, 'blueprints', blueprintId);
  await deleteDoc(blueprintRef);
  return true;
};

export const subscribeToBlueprint = (blueprintId, callback) => {
  const blueprintRef = doc(db, 'blueprints', blueprintId);
  return onSnapshot(blueprintRef, (doc) => {
    if (doc.exists()) {
      callback({ id: doc.id, ...doc.data() });
    } else {
      callback(null);
    }
  });
};

// Add other necessary Firestore interaction functions here (e.g., for components within a blueprint)
